import googleGlobalSiteTag from './scripts'

const props = {
  actionsQueue: [],
  googleActiveToken: undefined,
  googleAwToken: undefined,
  googleDcToken: undefined,
  initialized: false
}

// type Init = (?Tracker, ?Tracker) => GoogleTags;
export const init = (googleAwTracker, googleDcTracker) => {
  const googleAwToken = googleAwTracker && googleAwTracker.token
    ? googleAwTracker.token
    : undefined
  const googleDcToken = googleDcTracker && googleDcTracker.token
    ? googleDcTracker.token
    : undefined
  const googleActiveToken = googleDcToken || googleAwToken

  if (googleActiveToken) {
    googleGlobalSiteTag(googleActiveToken)

    const { gtag } = window

    if (gtag) {
      gtag('js', new Date())
      gtag('config', googleDcToken)
      gtag('config', googleAwToken)

      props.googleActiveToken = googleActiveToken
      props.googleAwToken = googleAwToken
      props.googleDcToken = googleDcToken
      props.actionsQueue.forEach(({ command, action, getFullData }) =>
        gtag(command, action, getFullData(googleActiveToken))
      )
      props.initialized = true
    }
  }
  return googleTags
}

export const track = (getGGProps) => {
  const { gtag } = window
  const getFullData = googleActiveToken => ({
    'allow_custom_scripts': true,
    ...getGGProps(googleActiveToken)
  })

  if (!props.initialized || !props.googleActiveToken) {
    props.actionsQueue.push({
      action: 'conversion',
      command: 'event',
      getFullData
    })
  } else {
    gtag('event', 'conversion', getFullData(props.googleActiveToken))
  }

  return googleTags
}

const googleTags = {
  init,
  track
}

export default googleTags
